export const ChevronDownIcon = () => (
    <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Expandir opciones"
    >
        <g clipPath="url(#clip0_3975_4975)">
            <path
                d="M2.86016 6.58562C2.45182 6.99395 2.45182 7.65229 2.86016 8.06062L9.78516 14.9856C10.1102 15.3106 10.6352 15.3106 10.9602 14.9856L17.8852 8.06062C18.2935 7.65229 18.2935 6.99395 17.8852 6.58562C17.4768 6.17729 16.8185 6.17729 16.4102 6.58562L10.3685 12.619L4.32682 6.57729C3.92682 6.17729 3.26015 6.17729 2.86016 6.58562Z"
                fill="#5C5C5C"
            />
        </g>
        <defs>
            <clipPath id="clip0_3975_4975">
                <rect
                    width="20"
                    height="20"
                    fill="white"
                    transform="matrix(0 1 -1 0 20.3672 0.435547)"
                />
            </clipPath>
        </defs>
    </svg>
);